import React, {Component}   from 'react';
import {Animated} from "react-animated-css";
import Container from "@material-ui/core/Container";
import {PageTitle} from "../../../../atomic/PageHeader/PageTitle";
import PageHeaderAtm from "../../../../atomic/PageHeader/PageHeader";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import PaymentMenu from "../../../Global/Layout/Header/Submenu/PaymentMenu";
import {
    getPaymentMappingList,
    getPaymentTypeList,
    createPaymentMapping,
    UpdatePaymentMapping,
    UpdatePaymentStatusMapping,
    PaymentStatusSetDefault,
    PaymentInstallmentUpdate,
    updatePaymentErrorClear,
    successPaymentClear,
    GetPaymentType
} from "../../../../../redux/actions/Payment/Payment.actions";
import {connect} from "react-redux";
import PaymentList from "./components/PaymentList";
import {PAYMENT_LIST, PAYMENT_INSTALLMENT_SHORT} from "../../../../../constants/appUrls.constants";
import {isDefined} from "../../../../../utils";
import {Grid} from "@material-ui/core";
import FooterAtm from "../../../../atomic/Footer/Footer";
import {Link} from "react-router-dom";
import { propertyProducts } from '../../../../../redux/actions/propertyProductsActions';

let t =null;

class PaymentSetupIndex extends Component {

    constructor(props){
        super(props);
        t = props.t;

        this.state= {
            paymentStatus: false
        }
    }

    componentDidMount() {
        document.body.style.backgroundColor = "#f4f7fc";
        this.props.getPaymentMappingList();
        this.props.getPaymentTypeList();
        if ( this.props.match.params.id )
        {
            this.props.GetPaymentType( { payment_type_id : this.props.match.params.id } );
            this.setState({
                payment_type_id:this.props.match.params.id
            })
        }
        else{
            this.props.history.replace('/payment');
        }

        if (!this.props.propertyProductsReducer?.get_products) {
            this.props.propertyProducts();
        }
    }

    // POS limiti kart listesinde (PaymentsBox) yalniz tiklamayi engelliyor;
    // kurulumu olmayan bir POS'un adresine dogrudan gelinirse limit asilmasin.
    componentDidUpdate() {
        const { paymentTypes, maxPosCount, match, history } = this.props;
        if (!paymentTypes) return;

        const currentType = paymentTypes.find(type => String(type?.id) === String(match.params.id));
        const setupCount = paymentTypes.filter(type => type?.has_setup).length;
        if (currentType && !currentType.has_setup && maxPosCount > 0 && setupCount >= maxPosCount) {
            history.replace(PAYMENT_LIST);
        }
    }

    render() {
        let installmentData = isDefined(this.props.paymentMapping.paymentGetList.currencies) && this.props.paymentMapping.paymentGetList.currencies.filter( (placesCategories) => {
            return placesCategories.code === "TRY"
        })

        const boxStatus = isDefined(this.props.paymentMapping.updatePaymentMappingBoxStatusData.data) && this.props.paymentMapping.updatePaymentMappingBoxStatusData.data.status;
        const responseCurrencyCode = isDefined(this.props.paymentMapping.updatePaymentMappingBoxStatusData.data) && this.props.paymentMapping.updatePaymentMappingBoxStatusData.data.currency_code;
        const tryCurrencyStatus =
            (boxStatus && responseCurrencyCode === "TRY") ?
                1 :
                (!boxStatus && responseCurrencyCode === "TRY") ?
                    0
                    :
                    isDefined(installmentData[0]) && installmentData[0].status;

        return (
            <>
                <PageTitle title={ t('enw-payment-payment_setup-page_title') } />
                        <>

                            <PageHeaderAtm
                                exitText={ t('btn-payment_list') }
                                backButton={PAYMENT_LIST}
                                text={isDefined(this.props.paymentMapping) && this.props.paymentMapping.paymentGetList.name + " "+ t('enw-payment-payment_setup-page_title')}
                            />
                            <PaymentMenu menuClass="channel-menu" setupColClass="active-menu-bg"
                                         menuId={this.props.match.params.id}
                                         bankName={isDefined(this.props.paymentMapping) && this.props.paymentMapping.paymentGetList.name}
                                         tryCurrencyStatus={tryCurrencyStatus}
                                         boxStatus={boxStatus}
                                         responseCurrencyCode={responseCurrencyCode}
                                         showInstallment={this.props.showInstallment}
                            />
                            <Animated animationIn="bounceInRight" animationInDuration={1000} isVisible={true}>
                                <Container maxWidth="xl">
                                    <div className="container-width cancellation-policy-list">
                                        {
                                            isDefined(this.props.paymentMapping) && !this.props.paymentMapping.paymentGetListFetching ?
                                            <PaymentList
                                                paymentMapping={this.props.paymentMapping}
                                                UpdatePaymentMapping={this.props.UpdatePaymentMapping}
                                                UpdatePaymentStatusMapping={this.props.UpdatePaymentStatusMapping}
                                                PaymentStatusSetDefault={this.props.PaymentStatusSetDefault}
                                                PaymentInstallmentUpdate={this.props.PaymentInstallmentUpdate}
                                                getPaymentMappingList={this.props.getPaymentMappingList}
                                                updatePaymentErrorClear={this.props.updatePaymentErrorClear}
                                                successPaymentClear={this.props.successPaymentClear}
                                                paymentTypeList={this.props.paymentMapping.paymentTypeList}
                                                paymentTypeGet={this.props.paymentMapping.paymentGetList}
                                                paymentGetListFetching={this.props.paymentMapping.paymentGetListFetching}
                                                createPaymentMapping={this.props.createPaymentMapping}
                                                GetPaymentType={this.props.GetPaymentType}
                                                maxCurrencyCount={this.props.maxCurrencyCount}
                                            />
                                                :
                                            <>
                                            </>
                                        }
                                    </div>
                                </Container>
                            </Animated>
                            {
                                (isDefined(this.props.paymentMapping) && !this.props.paymentMapping.paymentGetListFetching) &&
                                <Grid className="channel-logo-bottom">
                                    <img src={`/assets/img/logo/banks-logo/${this.props.paymentMapping.paymentGetList.bank_code}.jpg`} alt="mini-logo" />
                                </Grid>
                            }
                        </>
                {
                    (tryCurrencyStatus || (boxStatus && responseCurrencyCode === "TRY")) && this.props.showInstallment ?
                    <FooterAtm
                        buttonBackText={ t('btn-back') }
                        iconRightClassName="fas fa-arrow-right"
                        buttonBackStyle={{
                            fontSize: '16px',
                            fontWeight: 'bold',
                            textTransform: 'none',
                        }}
                        buttonNextStyle={{
                            fontSize: '16px',
                            fontWeight: 'bold',
                            textTransform: 'none',
                        }}
                        iconLeftClassName="fas fa-arrow-left"
                        buttonNextText={ t('btn-next') }
                        component={Link}
                        backDisabled={true}
                        nextTo={PAYMENT_INSTALLMENT_SHORT + this.props.match.params.id}
                        nextComponent={Link}
                    />
                    :
                        (!boxStatus && responseCurrencyCode === "TRY") ?
                            <></>
                            :
                    <></>
                }
            </>
        );
    }
}


const mapStateToProps = (props) => {
    const productsData = props.propertyProductsReducer;
    // 600-606 Booking Engine urununde (bkz. PaymentList/index.js).
    const bookingEngineProduct = !productsData?.fetching && productsData?.get_products
        ? Object.values(productsData.get_products.data).find(item => item.route === "booking-engine")
        : null;
    const posParam = bookingEngineProduct?.parameters?.find(
        p => p?.product_parameter_id === 600 && p?.is_selected === 1
    );
    const currencyParam = bookingEngineProduct?.parameters?.find(
        p => p?.product_parameter_id === 601 && p?.is_selected === 1
    );
    const installmentParam = bookingEngineProduct?.parameters?.find(
        p => p?.product_parameter_id === 603
    );
    const paymentTypes = props.paymentReducers?.paymentTypeList?.data?.payment_types;
    return {
        paymentMapping: props.paymentReducers,
        propertyProductsReducer: props.propertyProductsReducer,
        maxCurrencyCount: currencyParam ? parseInt(currencyParam.value, 10) : 999,
        maxPosCount: posParam ? parseInt(posParam.value, 10) : 999,
        paymentTypes: isDefined(paymentTypes) ? paymentTypes : null,
        showInstallment: bookingEngineProduct?.parameters?.length === 0 ? true : installmentParam?.is_selected === 1,
    };
};

const mapDispatchToProps ={
    getPaymentMappingList,
    getPaymentTypeList,
    createPaymentMapping,
    UpdatePaymentMapping,
    UpdatePaymentStatusMapping,
    PaymentStatusSetDefault,
    PaymentInstallmentUpdate,
    updatePaymentErrorClear,
    successPaymentClear,
    GetPaymentType,
    propertyProducts,
};

export default compose(withTranslation('common')) (connect(mapStateToProps, mapDispatchToProps )(PaymentSetupIndex));
